module.exports = __webpack_public_path__ + "static/media/Apple Pro Display XDR.07455b7d.png";